module.exports = __webpack_public_path__ + "img/icon_plus.cd246101.svg";